import React from 'react';
export function FormPageShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15576">
      <span className="sr-only" data-id="element-15577">Loading form…</span>
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-15578">
        <div className="h-6 w-48 bg-gray-200 rounded" data-id="element-15579" />
        <div className="flex gap-2" data-id="element-15580">
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15581" />
          <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15582" />
        </div>
      </div>
      {/* Form card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15583">
        <div className="space-y-6" data-id="element-15584">
          {/* Form sections */}
          {[1, 2].map(section => <div key={section} className="space-y-4" data-id="element-15585">
              <div className="h-5 w-32 bg-gray-200 rounded mb-4" data-id="element-15586" />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15587">
                {[1, 2, 3, 4].map(i => <div key={i} data-id="element-15588">
                    <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15589" />
                    <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-15590" />
                  </div>)}
              </div>
            </div>)}
          {/* Text area */}
          <div data-id="element-15591">
            <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15592" />
            <div className="h-32 w-full bg-gray-200 rounded-md" data-id="element-15593" />
          </div>
          {/* Action buttons */}
          <div className="flex justify-end gap-2 pt-4 border-t border-gray-200" data-id="element-15594">
            <div className="h-10 w-24 bg-gray-200 rounded-md" data-id="element-15595" />
            <div className="h-10 w-32 bg-gray-200 rounded-md" data-id="element-15596" />
          </div>
        </div>
      </div>
    </div>;
}